<div [ngClass]="rowClassName">
    <!-- Checkbox Column -->
    <div class="checkbox-column" *ngIf="withCheckbox">
        <mat-checkbox
            [checked]="rowViewModel.checkboxStatus ? true : false"
            (change)="onCheckboxClick()"
            [disabled]="(rowViewModel.disabledCheckbox && !withDeleteIcon) || rowViewModel.isStrictMode"
            (click)="checkboxEditable ? $event.stopPropagation() : $event.preventDefault()">
        </mat-checkbox>
    </div>

    <!-- Dynamic Columns Size -->
    <div
        class="dynamic-columns-size"
        [ngClass]="{
            'dynamic-columns-size-with-actions': withActions && !withActionsIcon,
            'dynamic-columns-size-with-actions-icon': withActions && withActionsIcon && !withCheckbox,
            'dynamic-columns-size-with-actions-icon-and-checkbox': withActions && withActionsIcon && withCheckbox,
            'dynamic-columns-size-with-delete-icon': withDeleteIcon,
        }">
        <!-- Content Columns -->
        <div
            class="content-col"
            (click)="onRowClick()"
            *ngFor="let col of rowColumns"
            [ngStyle]="{
                width:
                    col.widthType === WidthTypeEnum.Pixel
                        ? col.width.toString() + 'px'
                        : 'calc((100% - ' + columnsTotalStaticPixels.toString() + 'px) * ( ' + col.width.toString() + '/ 100 ))',
                'max-width': '600px',
            }">
            <!-- Not Applicable Label -->
            <div *ngIf="(rowViewModel | tableCell: col.propertyKey) && (rowViewModel | tableCell: col.propertyKey).toString() === notAvailableString">
                <app-not-applicable-label
                    [tooltipDynamicText]="col.tooltipDynamicText ? (rowViewModel | tableCell: col.tooltipDynamicText).toString() : 'Not applicable'">
                </app-not-applicable-label>
            </div>

            <!-- Severity Label -->
            <div *ngIf="col.colType === colTypesEnum.SeverityLabel">
                <app-severity-label [severity]="(rowViewModel | tableCell: col.propertyKey).toString()"> </app-severity-label>
            </div>

            <!-- Status Label -->
            <div *ngIf="col.colType === colTypesEnum.StatusLabel">
                <app-status-label [statusLabel]="(rowViewModel | tableCell: col.propertyKey).toString()" [disabled]="rowViewModel.disabled">
                </app-status-label>
            </div>

            <!-- Tags -->
            <div *ngIf="col.colType === colTypesEnum.Tag">
                <app-multiple-tags [tags]="(rowViewModel | tableCell: col.propertyKey).toString()"> </app-multiple-tags>
            </div>

            <!-- Toggle -->
            <div *ngIf="col.colType === colTypesEnum.Toggle" (click)="$event.stopPropagation()">
                <app-status-toggle
                    [inTable]="true"
                    [inputStatus]="rowViewModel.toggleState"
                    (toggleOnClick)="onToggleClick($event)"
                    (rowOnChangeState)="onRowOnChangeState($event)">
                </app-status-toggle>
            </div>

            <!-- Date Fields -->
            <div
                *ngIf="col.colType === colTypesEnum.Date && (rowViewModel | tableCell: col.propertyKey).toString() !== notAvailableString"
                class="date-field"
                [ngClass]="{ 'date-field-disabled': rowViewModel.disabled }"
                [title]="rowViewModel | tableCell: col.propertyKey">
                {{ $any(rowViewModel | tableCell: col.propertyKey) | date: "mediumDate" }}
            </div>

            <div
                *ngIf="col.colType === colTypesEnum.DateTime && (rowViewModel | tableCell: col.propertyKey).toString() !== notAvailableString"
                class="date-field"
                [ngClass]="{ 'date-field-disabled': rowViewModel.disabled }"
                [title]="rowViewModel | tableCell: col.propertyKey">
                {{ $any(rowViewModel | tableCell: col.propertyKey) | date: "medium" }}
            </div>

            <!-- Text Fields -->
            <div
                *ngIf="
                    col.colType === colTypesEnum.Text &&
                    col.tooltipDynamicText &&
                    (rowViewModel | tableCell: col.propertyKey).toString() !== notAvailableString
                "
                class="text-field"
                [ngClass]="{ 'text-field-disabled': rowViewModel.disabled }"
                appLongTextTooltip
                [matTooltip]="(rowViewModel | tableCell: col.tooltipDynamicText).toString()"
                matTooltipPosition="right"
                matTooltipClass="tooltip-container">
                {{
                    col.toCapitalize
                        ? ((rowViewModel | tableCell: col.propertyKey).toString().trim() | beautifyDisplayString)
                        : (rowViewModel | tableCell: col.propertyKey).toString().trim()
                }}
            </div>

            <div
                *ngIf="
                    col.colType === colTypesEnum.Text &&
                    !col.tooltipDynamicText &&
                    (rowViewModel | tableCell: col.propertyKey).toString() !== notAvailableString
                "
                class="text-field"
                [ngClass]="{ 'text-field-disabled': rowViewModel.disabled }"
                appLongTextTooltip>
                {{
                    col.toCapitalize
                        ? ((rowViewModel | tableCell: col.propertyKey).toString().trim() | beautifyDisplayString)
                        : (rowViewModel | tableCell: col.propertyKey).toString().trim()
                }}
            </div>

            <!-- Text with Icon -->
            <div
                *ngIf="col.colType === colTypesEnum.TextWithIcon && (rowViewModel | tableCell: col.propertyKey).toString() !== notAvailableString"
                class="text-with-icon">
                <img class="icon" [src]="rowViewModel | tableCell: col.propertyKey + 'Icon'" />

                <div class="text" [ngClass]="{ 'text-disabled': rowViewModel.disabled }" appLongTextTooltip>
                    {{
                        col.toCapitalize
                            ? ((rowViewModel | tableCell: col.propertyKey).toString().trim() | beautifyDisplayString)
                            : (rowViewModel | tableCell: col.propertyKey).toString().trim()
                    }}
                </div>
            </div>

            <!-- Links -->
            <div
                *ngIf="col.colType === colTypesEnum.Link && (rowViewModel | tableCell: col.propertyKey).toString() !== notAvailableString"
                class="text-field"
                appLongTextTooltip>
                <a
                    [href]="col.linkPropertyKey ? (rowViewModel | tableCell: col.linkPropertyKey).toString() : ''"
                    [target]="
                        rowViewModel.hrefTarget && rowViewModel.hrefTarget === supportedHrefTypes.self
                            ? supportedHrefTypes.self
                            : supportedHrefTypes.blank
                    "
                    class="link-field"
                    appLongTextTooltip>
                    {{
                        col.toCapitalize
                            ? ((rowViewModel | tableCell: col.propertyKey).toString().trim() | beautifyDisplayString)
                            : (rowViewModel | tableCell: col.propertyKey).toString().trim()
                    }}
                </a>
            </div>

            <!-- Number Fields -->
            <div *ngIf="col.colType === colTypesEnum.Number" class="number-field" [ngClass]="{ 'number-field-disabled': rowViewModel.disabled }">
                {{ $any(rowViewModel | tableCell: col.propertyKey) | number }}
            </div>

            <!-- Internal Navigation Links -->
            <a
                *ngIf="
                    col.colType === colTypesEnum.InternalNavigation &&
                    !col.tooltipDynamicText &&
                    $any(rowViewModel | tableCell: col.internalNavigationRoute ?? '')
                "
                class="text-field text-navigation"
                [routerLink]="col.internalNavigationRoute ? (rowViewModel | tableCell: col.internalNavigationRoute).toString() : []"
                routerLinkActive="active"
                [queryParams]="col.internalNavigationQuery ? $any(rowViewModel | tableCell: col.internalNavigationQuery) : {}">
                {{ rowViewModel | tableCell: col.propertyKey }}
            </a>

            <a
                *ngIf="
                    col.colType === colTypesEnum.InternalNavigation &&
                    col.tooltipDynamicText &&
                    $any(rowViewModel | tableCell: col.internalNavigationRoute ?? '')
                "
                class="text-field text-navigation"
                [routerLink]="col.internalNavigationRoute ? (rowViewModel | tableCell: col.internalNavigationRoute).toString() : []"
                routerLinkActive="active"
                [queryParams]="col.internalNavigationQuery ? $any(rowViewModel | tableCell: col.internalNavigationQuery) : {}"
                appLongTextTooltip
                [matTooltip]="(rowViewModel | tableCell: col.tooltipDynamicText).toString()"
                matTooltipPosition="right"
                matTooltipClass="tooltip-container">
                {{ rowViewModel | tableCell: col.propertyKey }}
            </a>

            <div
                *ngIf="
                    col.colType === colTypesEnum.InternalNavigation &&
                    col.tooltipDynamicText &&
                    !$any(rowViewModel | tableCell: col.internalNavigationRoute ?? '')
                "
                class="text-with-icon">
                <img
                    class="icon"
                    *ngIf="rowViewModel | tableCell: (col.propertyKey + 'Icon')"
                    [src]="rowViewModel | tableCell: col.propertyKey + 'Icon'"
                    [ngClass]="{
                        'icon-big': rowViewModel | tableCell: col.propertyKey + 'IconBig',
                    }" />

                <div
                    class="text-field"
                    [ngClass]="{ 'text-field-disabled': rowViewModel.disabled }"
                    [matTooltip]="(rowViewModel | tableCell: col.tooltipDynamicText).toString()"
                    matTooltipPosition="right"
                    matTooltipClass="long-text-tooltip-container">
                    {{
                        col.toCapitalize
                            ? ((rowViewModel | tableCell: col.propertyKey).toString().trim() | beautifyDisplayString)
                            : (rowViewModel | tableCell: col.propertyKey).toString().trim()
                    }}
                </div>
            </div>

            <a
                *ngIf="
                    col.colType === colTypesEnum.InternalNavigation &&
                    !col.tooltipDynamicText &&
                    !$any(rowViewModel | tableCell: col.internalNavigationRoute ?? '')
                "
                class="text-field"
                [ngClass]="{ 'text-field-disabled': rowViewModel.disabled }"
                appLongTextTooltip>
                {{
                    col.toCapitalize
                        ? ((rowViewModel | tableCell: col.propertyKey).toString().trim() | beautifyDisplayString)
                        : (rowViewModel | tableCell: col.propertyKey).toString().trim()
                }}
            </a>

            <!-- Icons -->
            <img
                *ngIf="col.colType === colTypesEnum.Icon && col.tooltipDynamicText"
                class="icon-field"
                [src]="rowViewModel | tableCell: col.propertyKey"
                appLongTextTooltip
                [ngClass]="[col.iconTableClass ? col.iconTableClass : '', col.iconBorder ? 'icon-border' : '']"
                [matTooltip]="(rowViewModel | tableCell: col.tooltipDynamicText).toString()"
                matTooltipPosition="right"
                matTooltipClass="tooltip-container" />

            <!-- Modified Icon -->
            <img
                *ngIf="col.colType === colTypesEnum.Icon && !col.tooltipDynamicText"
                class="icon-field"
                [src]="rowViewModel | tableCell: col.propertyKey"
                [ngClass]="[col.iconTableClass ? col.iconTableClass : '', col.iconBorder ? 'icon-border' : '']" />

            <!-- Copyable Text -->
            <img
                *ngIf="col.colType === colTypesEnum.Modified && rowViewModel.modified"
                class="icon-field"
                src="assets/images/common/info.svg"
                [ngClass]="col.iconTableClass ? col.iconTableClass : ''"
                [matTooltip]="col.tooltipIconText || ''"
                matTooltipPosition="above"
                alt="info"
                matTooltipClass="tooltip-container" />

            <div *ngIf="col.colType === colTypesEnum.CopyableText" class="copyable-field">
                <app-copy-button
                    class="copy-button"
                    [value]="
                        col.toCapitalize
                            ? ((rowViewModel | tableCell: col.propertyKey).toString().trim() | beautifyDisplayString)
                            : (rowViewModel | tableCell: col.propertyKey).toString().trim()
                    "
                    text="{{
                        col.customCopyButtonTextLabel
                            ? (col.customCopyButtonTextLabel | labelsProvider)
                            : col.toCapitalize
                              ? ((rowViewModel | tableCell: col.propertyKey).toString().trim() | beautifyDisplayString)
                              : (rowViewModel | tableCell: col.propertyKey).toString().trim()
                    }}"
                    [isSecondaryFontColor]="true"
                    [withCopyIcon]="col.withCopyIcon ? true : false">
                </app-copy-button>
            </div>

            <div *ngIf="col.colType === colTypesEnum.DropDownOptions" class="dropdown-field">
                <app-select
                    class="dropdown-field-options"
                    [optionSelected]="rowViewModel | selectOptionTableCell: col.propertyKey"
                    [options]="dropDownOptions"
                    (optionOnSelection)="onDropDownSelectOption($event)"
                    [withoutShowingSelection]="false"
                    [useBeutifyStringProviderPipe]="true"
                    [disabled]="rowViewModel.disabled || rowViewModel.isStrictMode"></app-select>
            </div>
        </div>
    </div>

    <!-- Actions Column -->
    <div class="actions-column" *ngIf="withActions && !withActionsIcon && rowViewModel.menuActions && rowViewModel.menuActions.length > 0">
        <app-actions-menu-select
            class="actions"
            [actions]="(menuActions$ | async) ?? []"
            (actionOnClick)="actionOnClick($event)"
            (click)="onMenuClick()"
            (clickOutside)="onOutsideMenuClick()">
        </app-actions-menu-select>
    </div>

    <div class="actions-column-icon" *ngIf="withActions && withActionsIcon && rowViewModel.menuActions && rowViewModel.menuActions.length > 0">
        <app-actions-menu-icon class="actions-icon" [actions]="menuActions" (actionOnClick)="actionOnClick($event)" [smallSize]="true">
        </app-actions-menu-icon>
    </div>

    <!-- Delete Column -->
    <div class="delete-column" *ngIf="withDeleteIcon && !rowViewModel.isStrictMode">
        <img
            src="assets/images/common/delete.svg"
            class="delete-icon"
            (click)="rowViewModel.isStrictMode ? $event.stopPropagation() : onDeleteIconClicked()" />
    </div>

    <div class="delete-column-disabled" *ngIf="withDeleteIcon && rowViewModel.isStrictMode">
        <img
            src="assets/images/common/delete.svg"
            class="delete-icon-disabled"
            (click)="$event.stopPropagation()"
            matTooltip="You cannot delete your own user"
            matTooltipClass="tooltip-container"
            matTooltipPosition="below" />
    </div>

    <div *ngIf="rowViewModel.statusChanged" class="circle"></div>
    <div class="row-separation-line"></div>
</div>
